import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FaBan, FaCheckCircle, FaEdit, FaUserCircle } from 'react-icons/fa';
import { driverConfirm } from 'redux/booking/car/carBookingSlice';
import { ActionDropdown, Badge } from 'components/common';
import TransactionDetailDriverTransFormModal from './TransactionDetailDriverTransFormModal';
import DriverTranDeleteConfirm from './DriverTranDeleteConfirm';

const Line = ({ label, children }) => (
  <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-0.5 sm:tw-gap-2 tw-mb-1 tw-text-sm">
    <span className="sm:tw-w-32 sm:tw-flex-shrink-0 tw-text-slate-500">{label}</span>
    <span className="tw-text-blue-700">{children}</span>
  </div>
);

Line.propTypes = { label: PropTypes.string.isRequired, children: PropTypes.node };

const TransactionDetailApprovalDriver = ({ transaction }) => {
  const [showForm, setShowForm] = useState(false);
  const [driverTran, setDriverTran] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const driver_trans = transaction?.driver_trans || [];
  const dispatch = useDispatch();

  const handleConfirm = (driverTranId) => dispatch(driverConfirm({ transactionId: transaction.id, driverTranId }));

  const handleEditDriverTran = (id) => {
    setDriverTran(driver_trans.find((item) => item.id === id));
    setShowForm(true);
  };

  const handleDeleteDriverTran = (record) => {
    setDriverTran(record);
    setShowDeleteConfirm(true);
  };

  const DriverItem = ({ driver_tran }) => {
    const { allow_hr_admin_edit, allow_confirm, allow_delete } = driver_tran?.permissions || {};

    const actions = [];
    if (allow_hr_admin_edit) actions.push({ label: 'Edit transaction', icon: <FaEdit />, onClick: () => handleEditDriverTran(driver_tran.id) });
    if (allow_delete) {
      if (actions.length) actions.push({ divider: true });
      actions.push({ label: 'Cancel', icon: <FaBan />, danger: true, onClick: () => handleDeleteDriverTran(driver_tran) });
    }

    return (
      <div className="tw-border tw-border-solid tw-border-slate-200 tw-rounded tw-p-4 tw-mb-3 tw-bg-white">
        {actions.length > 0 && (
          <div className="tw-flex tw-justify-end tw-mb-2">
            <ActionDropdown items={actions} />
          </div>
        )}

        <Line label="Car number">{driver_tran.car?.name} / <strong>{driver_tran.car?.model}</strong></Line>
        <Line label="Driver name">{driver_tran.driver?.name}</Line>
        <Line label="Email">{driver_tran.driver?.email}</Line>
        <Line label="Phone number">{driver_tran.driver?.phone}</Line>

        {driver_tran.confirmed ? (
          <>
            <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-0.5 sm:tw-gap-2 tw-mb-1 tw-text-sm tw-mt-3">
              <span className="sm:tw-w-32 sm:tw-flex-shrink-0 tw-text-red-600">Confirmed?</span>
              <FaCheckCircle className="tw-text-green-600" size={20} />
            </div>
            <Line label="Confirmed date">{driver_tran.confirmed_date}</Line>
            <Line label="Confirmed by"><FaUserCircle className="tw-inline tw-mr-1" /> {driver_tran.confirmed_by}</Line>
          </>
        ) : (
          <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-0.5 sm:tw-gap-2 tw-mt-3 tw-text-sm">
            <span className="sm:tw-w-32 sm:tw-flex-shrink-0 tw-text-red-600">Confirmed?</span>
            <div>
              <Badge variant="warning" size="sm">Waiting for confirmation by driver!</Badge>
              {allow_confirm && (
                <div className="tw-mt-1 tw-text-right">
                  Click here to{' '}
                  <button type="button" onClick={() => handleConfirm(driver_tran.id)}
                    className="tw-bg-transparent tw-border-0 tw-text-blue-600 tw-font-semibold tw-cursor-pointer tw-p-0 hover:tw-underline">
                    Confirm!
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  DriverItem.propTypes = {
    driver_tran: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      permissions: PropTypes.object,
      car: PropTypes.shape({ name: PropTypes.string, model: PropTypes.string }),
      driver: PropTypes.shape({ name: PropTypes.string, email: PropTypes.string, phone: PropTypes.string }),
      confirmed: PropTypes.bool,
      confirmed_date: PropTypes.string,
      confirmed_by: PropTypes.string
    }).isRequired
  };


  return (
    <>
      <div>
        {Array.isArray(driver_trans) && driver_trans.map((item) => (
          <DriverItem driver_tran={item} key={item.id} />
        ))}

      </div>

      {showForm && (
        <TransactionDetailDriverTransFormModal
          showModal={showForm}
          setshowModal={setShowForm}
          transaction={transaction}
          driverTran={driverTran}
        />
      )}

      {showDeleteConfirm && (
        <DriverTranDeleteConfirm
          showModal={showDeleteConfirm}
          setshowModal={setShowDeleteConfirm}
          transaction={transaction}
          driverTran={driverTran}
        />
      )}
    </>
  );
};

TransactionDetailApprovalDriver.propTypes = {
  transaction: PropTypes.object.isRequired,
};

export default TransactionDetailApprovalDriver;
